/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getOrderHistoryByPONumberAsync } from './SearchItemsDataActionExtension.g';
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';

/**
 * searchOrderHistoryByPo Input Action
 */
export interface IITSsearchOrderHistoryByPoInput extends Msdyn365.IActionInput {
    pONumber: string;
    customerAccount: string;
    businessPartnerId: string;
}

export class searchOrderHistoryByPoInput implements Msdyn365.IActionInput {
    public pONumber: string;
    public customerAccount: string;
    public businessPartnerId: string;
    constructor(pONumber: string, customerAccount: string, businessPartnerId: string) {
        this.pONumber = pONumber;
        this.customerAccount = customerAccount;
        this.businessPartnerId = businessPartnerId;
    }

    public getCacheKey = () => `searchOrderHistoryByPO`;
    public getCacheObjectType = () => 'searchOrderHistoryByPO';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

export async function searchOrderHistorybyPOAction(
    request: IITSsearchOrderHistoryByPoInput,
    ctx: Msdyn365.IActionContext
): Promise<Entities.SalesOrder[] | []> {
    if (request.pONumber) {
        try {
            const result = await getOrderHistoryByPONumberAsync(
                { callerContext: ctx },
                request.pONumber,
                request.customerAccount,
                request.businessPartnerId
            );
            if (result) {
                return result;
            }
        } catch (error) {
            console.log('Error', error);
        }
    }
    return [];
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<Entities.SalesOrder[]>>searchOrderHistorybyPOAction,
    id: 'searchOrderHistoryByPO'
});
